import { find, isEmpty, isNil, pull } from 'lodash';
import type { ProductGroup } from 'models/product/productGroup';

export function findGroupById(
  groups: ProductGroup[],
  id: number,
  path: ProductGroup[] = []
): { group: ProductGroup; path: ProductGroup[] } | undefined {
  const group = find(groups, (g) => g.id === id);

  if (!isNil(group)) {
    return { group, path: [...path, group] };
  }

  for (const nestedGroup of groups) {
    if (!isEmpty(nestedGroup.groups)) {
      const foundGroup = findGroupById(nestedGroup.groups, id, [...path, nestedGroup]);
      if (foundGroup) {
        return foundGroup;
      }
    }
  }

  return undefined;
}

export function removeGroupById(groups: ProductGroup[], id: number): boolean {
  for (const group of groups) {
    if (group.id === id) {
      pull(groups, group);
      return true;
    }

    if (!isEmpty(group.groups)) {
      const removed = removeGroupById(group.groups, id);
      if (removed) {
        return true;
      }
    }
  }

  return false;
}
